import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLeftToLine } from '@fortawesome/pro-solid-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { _js } from '@ifixit/utils/localize';

export const GridRemoveColumnButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().decreaseColumns().run()}
         isDisabled={!editor.can().decreaseColumns()} // Assuming a can method to check if columns can be decreased
         icon={<FontAwesomeIcon icon={faLeftToLine} />}
         title={_js('Remove column')}
      />
   );
};
